import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { init as initMainComponents } from './main-components.js';

export const init = () => {
  initMainComponents();
};
